import {Model} from '@vuex-orm/core'
import Article from '@models/helpers/Article'

export default class Countryprice extends Model {
  static entity = 'countryprices';

  static fields() {
    return {
      id: this.attr(null),
      unit_price: this.number(0),
      country_id: this.number(0),
      article_id: this.number(0),
      valid_from: this.attr(null),
      valid_to: this.attr(null),

      article: this.belongsTo(Article, 'article_id')
    }
  }
}
